import { FC } from 'react';

import { IconProps } from '../types';

const LactoseFreeIcon: FC<IconProps> = ({ size, ...props }) => (
  <svg
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    {...props}
    aria-hidden="true"
  >
    <path
      d="M24.813 34.07L15.6507 35.5L9.31299 32.6313V9.38126L11.4818 7.37756L12.4818 5.36503L21.6441 4.5V6.51253L24.813 10.1315V20.1775"
      stroke="#030303"
      strokeWidth="2"
      strokeLinecap="square"
      strokeLinejoin="round"
    />
    <path
      d="M24.8132 10.1316L15.6509 11.1025V35.5"
      stroke="#030303"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.4819 7.37744L15.6508 11.1024"
      stroke="#030303"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <circle
      cx="27.5"
      cy="27.5"
      r="7.25"
      fill="white"
      stroke="#030303"
      strokeWidth="2"
    />
    <path
      d="M30.5322 24.4804C30.28 24.2282 29.8702 24.2282 29.618 24.4804L27.5013 26.5971L25.3846 24.4804C25.1324 24.2282 24.7226 24.2282 24.4704 24.4804C24.2182 24.7326 24.2182 25.1424 24.4704 25.3946L26.5871 27.5113L24.4704 29.628C24.2182 29.8802 24.2182 30.29 24.4704 30.5422C24.5965 30.6683 24.7631 30.7314 24.9275 30.7314C25.0919 30.7314 25.2585 30.6683 25.3846 30.5422L27.5013 28.4256L29.618 30.5422C29.7441 30.6683 29.9107 30.7314 30.0751 30.7314C30.2395 30.7314 30.4061 30.6683 30.5322 30.5422C30.7844 30.29 30.7844 29.8802 30.5322 29.628L28.4155 27.5113L30.5322 25.3946C30.7844 25.1424 30.7844 24.7326 30.5322 24.4804Z"
      fill="#030303"
      stroke="#030303"
      strokeWidth="0.75"
    />
  </svg>
);

export default LactoseFreeIcon;
